/**
 * Constants and configuration for Bill Part Pricing Control composite
 */

export enum PricingAction {
  UPDATE = 'update',
  KEEP = 'keep',
  PENDING = 'pending',
  CREATE_NEW_PART = 'create_new_part',
  SKIP = 'skip',
  CREATE_SELLING_OPTION_LINKED = 'create_selling_option_linked',
  CREATE_SELLING_OPTION_INDEPENDENT = 'create_selling_option_independent',
}

export const PRICING_CONTROL_CONFIG = {
  // Minimum price difference percentage to highlight changes
  MIN_HIGHLIGHT_PERCENTAGE: 5,

  // Maximum price difference percentage to warn user
  MAX_SAFE_PERCENTAGE: 50,

  // Default currency for display
  DEFAULT_CURRENCY: 'CAD',

  // Debounce delay for bulk operations (ms)
  BULK_OPERATION_DEBOUNCE: 300,

  // Maximum items to process in a single batch
  MAX_BATCH_SIZE: 100,
} as const

export const PRICING_VALIDATION = {
  // Minimum allowed price
  MIN_PRICE: 0.01,

  // Maximum allowed price
  MAX_PRICE: 999999.99,

  // Maximum allowed percentage change
  MAX_PERCENTAGE_CHANGE: 1000,
} as const

export const UI_CONSTANTS = {
  // Animation durations
  TRANSITION_DURATION: 200,

  // Loading states
  LOADING_DEBOUNCE: 150,

  // Error display duration
  ERROR_DISPLAY_DURATION: 5000,
} as const
